import React from "react";
import PropTypes from "prop-types";

import Card from "../../../../../../../components/Card";
import { clx } from "../../../../../../../utils/Helpers";
import ReviewDiffField from "./ReviewDiffField";

const ReviewDiffSection = ({ variant, title, fields, fileOpenLabel }) => {
  const cols = variant === "contact" ? 3 : variant === "documents" ? 1 : 2;

  return (
    <Card
      title={title}
      classNames={{ body: "review-profile-diff-section__body" }}
    >
      <div
        className={clx(
          "company-view-field-grid",
          `company-view-field-grid--cols-${cols}`,
        )}
      >
        {fields.map((f) => (
          <ReviewDiffField
            key={f.label}
            label={f.label}
            changed={f.changed}
            display={f.display}
            oldValue={f.oldValue}
            newValue={f.newValue}
            valueAccent={f.valueAccent}
            valueClassName={f.valueClassName}
            fileUrl={variant === "documents" ? f.fileUrl : undefined}
            oldFileUrl={variant === "documents" ? f.oldFileUrl : undefined}
            newFileUrl={variant === "documents" ? f.newFileUrl : undefined}
            fileOpenLabel={variant === "documents" ? fileOpenLabel : undefined}
          />
        ))}
      </div>
    </Card>
  );
};

ReviewDiffSection.propTypes = {
  variant: PropTypes.oneOf(["company", "contact", "documents"]).isRequired,
  title: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  fileOpenLabel: PropTypes.string,
};

ReviewDiffSection.defaultProps = {
  fileOpenLabel: undefined,
};

export default ReviewDiffSection;
